import React from "react";
import { Alert } from "antd";
import styles from "./styles.module.less";
import { usePerfil } from "./usePerfil";
import { isLocalhost } from "../../apis/backend/Api";
import { LazySuspense } from "../../components/layout/AppHeader/lazySuspense";
import { selectStoreUsuarioActivo } from "../../redux/helpers/selectStore";

const AppHeader = React.lazy(
  () => import("../../components/layout/AppHeader/appHeader"),
);
const AppFooter = React.lazy(
  () => import("../../components/layout/AppFooter/AppFooter"),
);
export const ProtectedRoleResourceManager = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const objUsuarioStore = selectStoreUsuarioActivo();
  let perfil = usePerfil("4");

  if (isLocalhost) return children;

  const perfilesPermitidos = ["6", "4"];

  const tienePermiso = (idPerfil: string) =>
    perfilesPermitidos.includes(idPerfil);

  // Uso
  if (tienePermiso(objUsuarioStore.IdPerfil)) {
    return children;
  }

  if (!perfil.isPerfil) {
    return NotAuthorized();
  } else {
    return children;
  }
};
function NotAuthorized() {
  return (
    <>
      <div>
        <LazySuspense>
          <AppHeader />
        </LazySuspense>
        <div className={styles.contentStyle}>
          <Alert message={"Usuario no autorizado"} type={"warning"} />
        </div>
      </div>

      <LazySuspense>
        <AppFooter />
      </LazySuspense>
    </>
  );
}
